import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { KcfSelectionState, ResetPatientKcfSelectionPayload, ToggleKcfFactPayload } from "./index.types";

const initialState: KcfSelectionState = {
  // Marked key clinical facts by patientId
  selectedFactIds: {},
};

export const kcfSelectionSlice = createSlice({
  name: "kcfSelection",
  initialState,
  reducers: {
    // Mark or unmark a fact for the end note. Held here rather than in a screen's
    // local state because the patient dashboard and the interim screen never
    // coexist - the dashboard unmounts when the end-visit flow opens - and the
    // selection has to survive that transition.
    toggleKcfFact: (state, { payload }: PayloadAction<ToggleKcfFactPayload>) => {
      const { patientId, factId } = payload;
      const key = String(patientId);
      const current = state.selectedFactIds[key] || [];

      state.selectedFactIds[key] = current.includes(factId) ? current.filter((id) => id !== factId) : [...current, factId];
    },

    // Clear the selection for one patient
    resetPatientKcfSelection: (state, { payload }: PayloadAction<ResetPatientKcfSelectionPayload>) => {
      const key = String(payload.patientId);
      if (state.selectedFactIds[key]) {
        delete state.selectedFactIds[key];
      }
    },
  },
});

export const { toggleKcfFact, resetPatientKcfSelection } = kcfSelectionSlice.actions;

export default kcfSelectionSlice.reducer;
